/*通用申请表*/
import request from '@/utils/request'

export function addForm(data) {
    return request({
        url: '/com/application-form/add',
        method: 'post',
        params: data
    })
}